export default class Tabs {

    constructor() {

        this.settings = {
            el: $('.js-tabular-content')
        };

        this.bindUIActions();

    }

    bindUIActions() {

        if(this.settings.el != null) {
            const tabClass = '.js-tabular-content'; // The container element that holds the tabs
            const tabPaneClass = '.tabular-content__pane'; // Individual tab navigation element
            const tabContentClass = '.tabular-content__section'; // Individual tab content element
            const $tabs = $(tabPaneClass);

            // Loop through each tab and add a click event listener
            $.each($tabs, (index, tab) => {
                $(tab).on('click', (e) => {
                    // Prevent the browser from following any link or button behavior
                    e.preventDefault();
                    const $this = $(e.target); // The current tab that was clicked
                    const paneTarget = $this.attr('data-target'); // The target pane to show
                    const $parent = $this.closest('.js-tabular-content'); // Find the ancestor element with the .js-tabular-content class
                    const $activeTabBorder = $this.find('.js-tabs-border'); // The current tab's border element

                    // Removes the active class from all tab panes within the same tab container
                    $parent.find(tabPaneClass).removeClass('tabular-content__active');
                    // Add the active class to the current tab
                    $this.addClass('tabular-content__active');
                    // Show the border element of the current tab
                    $activeTabBorder.removeClass('opacity-0');
                    $activeTabBorder.addClass('opacity-100');
                    // Hide all tab content elements
                    $parent.find(tabContentClass).hide();
                    // Show the current tab content element
                    $parent.find('.' + paneTarget).fadeIn(300);

                });
            });

            // Triggers a click event on the first tab pane to show the first tab content by default
            $(tabClass).each((index, item) => {
                $(item).find(tabPaneClass).first().trigger('click');
            });
        }
    }
}

new Tabs();